// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Table {
  --sp-table-bold: 700;
  --sp-table-regular: 500;
  --sp-table-gutter-x: 0.5rem;
  --sp-table-gutter-y: 0.65rem;
  --sp-border-color: #ccc;
  --sp-table-header-bg: #fff;
  --sp-table-footer-bg: #fff;
  --sp-table-row-height: calc(var(--sp-table-gutter-y) * 2 + 1.5rem);
  --sp-table-sort-indicator-color: rgba(0, 0, 0, 0.25);
  --sp-table-alternate-shading: rgba(197, 197, 197, 0.2);
  position: relative;
  display: flex;
  gap: 0.5rem;
  width: 100%;
}
.Table:has(.Table-Controls) {
  width: calc(100% + 3.5rem);
}
.Table table {
  position: relative;
  flex-grow: 1;
  width: 100%;
  height: 100%;
  border-spacing: 0;
}
.Table table .TableRow {
  position: relative;
  display: block;
}
.Table table .TableRow .TableCell {
  position: relative;
  display: inline-flex;
}
.Table table .TableRow .TableCell .TableCell-Content {
  position: relative;
  flex-grow: 1;
  min-height: var(--sp-table-row-height);
  font-weight: var(--sp-table-regular);
  padding: var(--sp-table-gutter-y) calc(var(--sp-table-gutter-x) / 2);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.Table table .TableRow .TableCell .TableCell-Content .SortingIndicator {
  padding: var(--sp-table-gutter-y) 0;
  margin-left: var(--sp-table-gutter-x);
  color: var(--sp-table-sort-indicator-color);
}
.Table table .TableRow .TableCell .TableCell-Content .SortingIndicator.SortingIndicator-asc, .Table table .TableRow .TableCell .TableCell-Content .SortingIndicator.SortingIndicator-desc {
  color: inherit;
}
.Table table .TableRow .TableCell.alternate {
  background-color: var(--sp-table-alternate-shading);
}
.Table table .TableRow .TableCell:has(.SortingIndicator) {
  cursor: pointer;
}
.Table table .TableRow .TableCell:first-child .TableCell-Content {
  padding-left: var(--sp-table-gutter-x);
}
.Table table .TableRow .TableCell:last-child .TableCell-Content {
  padding-right: var(--sp-table-gutter-x);
}
.Table table .TableRow .TableCell[data-prefix] {
  --prefix: attr(data-prefix);
}
.Table table .TableRow .TableCell[data-prefix] .TableCell-Content:before {
  content: var(--prefix);
  display: inline;
  color: rgba(0, 0, 0, 0.5);
}
.Table table .TableRow .TableCell[data-suffix] {
  --suffix: attr(data-suffix);
}
.Table table .TableRow .TableCell[data-suffix] .TableCell-Content:after {
  content: var(--suffix);
  display: inline;
  color: rgba(0, 0, 0, 0.5);
}
.Table table .TableRow .TableCell[data-placeholder] {
  --placeholder: attr(data-placeholder);
}
.Table table .TableRow .TableCell[data-placeholder] .TableCell-Content:empty:before {
  content: var(--placeholder);
  display: inline;
  color: rgba(0, 0, 0, 0.5);
}
.Table table .TableRow.TableRow-Header .TableCell .TableCell-Content {
  text-transform: uppercase;
  font-weight: var(--sp-table-bold);
}
.Table table .TableRow.TableRow-Header .TableCell .TableCell-Content:has(.SortingIndicator) {
  cursor: pointer;
}
.Table table .TableCollapse {
  box-shadow: 0 2px 0 -1px var(--sp-border-color);
}
.Table table .TableCollapse td {
  padding: 0;
}
.Table table .Table-Head {
  position: sticky;
  top: 0;
  z-index: 2;
}
.Table table .Table-Head > .TableRow {
  background: var(--sp-table-header-bg);
  box-shadow: 0 2px 0 -1px var(--sp-border-color);
}
.Table table .Table-Body > .TableRow:has(+ .TableRow), .Table table .Table-Body > .TableRow:has(+ .TableCollapse) {
  box-shadow: 0 1px 0 0 var(--sp-border-color);
}
.Table table .Table-Body > .TableRow:hover:after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: calc(100% - 1px);
  height: calc(100% - 0px);
  border: 3px solid var(--bs-secondary);
  border-radius: 0.5rem;
  pointer-events: none;
}
.Table table .Table-End {
  height: 1rem;
}
.Table table .Table-Foot {
  position: sticky;
  bottom: calc((var(--sp-table-row-height) + 3px) * -1);
  z-index: 1;
}
.Table table .Table-Foot > .TableRow {
  background: var(--sp-table-footer-bg);
  box-shadow: 0 -1px 0 0 var(--sp-border-color);
}
.Table table:has(thead) .TableRow {
  scroll-margin-top: calc(var(--sp-table-row-height) + 2px);
}
.Table table:has(tfoot) .TableRow {
  scroll-margin-bottom: calc(var(--sp-table-row-height));
}
.Table .Table-Controls {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  flex-grow: 0;
  padding: 0.5rem 0;
}
.Table .Table-Controls .Table-ScrollDown,
.Table .Table-Controls .Table-ScrollUp {
  position: sticky;
  z-index: 2;
}
.Table .Table-Controls .Table-ScrollDown {
  top: 0.5rem;
}
.Table .Table-Controls .Table-ScrollUp {
  top: 100%;
}
.Table .Table-Controls .Table-Addons {
  position: sticky;
  top: 3.4rem;
  bottom: 3.4rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding-bottom: 2.9rem;
}
.Table .Table-Controls .btn-secondary-subtle {
  border: 1px solid var(--sp-border-color);
}
.Table strong {
  font-weight: var(--sp-table-bold) !important;
}

.Table .Table .Table-End {
  height: 0;
}`, "",{"version":3,"sources":["webpack://./src/common/Table/styles.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;EACA,uBAAA;EACA,2BAAA;EACA,4BAAA;EACA,uBAAA;EACA,0BAAA;EACA,0BAAA;EACA,kEAAA;EACA,oDAAA;EACA,sDAAA;EAEA,kBAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;AAAF;AACE;EACE,0BAAA;AACJ;AACE;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AACJ;AAAI;EACE,kBAAA;EACA,cAAA;AAEN;AADM;EACE,kBAAA;EACA,oBAAA;AAGR;AAFQ;EACE,kBAAA;EACA,YAAA;EACA,sCAAA;EACA,oCAAA;EACA,oEAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AAIV;AAHU;EACE,mCAAA;EACA,qCAAA;EACA,2CAAA;AAKZ;AAJY;EAEE,cAAA;AAKd;AADQ;EACE,mDAAA;AAGV;AADQ;EACE,eAAA;AAGV;AAAU;EACE,sCAAA;AAEZ;AAEU;EACE,uCAAA;AAAZ;AAGQ;EACE,2BAAA;AADV;AAGY;EACE,sBAAA;EACA,eAAA;EACA,yBAAA;AADd;AAKQ;EACE,2BAAA;AAHV;AAKY;EACE,sBAAA;EACA,eAAA;EACA,yBAAA;AAHd;AAOQ;EACE,qCAAA;AALV;AAOY;EACE,2BAAA;EACA,eAAA;EACA,yBAAA;AALd;AAYU;EACE,yBAAA;EACA,iCAAA;AAVZ;AAWY;EACE,eAAA;AATd;AAeI;EACE,+CAAA;AAbN;AAcM;EACE,UAAA;AAZR;AAeI;EACE,gBAAA;EACA,MAAA;EACA,UAAA;AAbN;AAcM;EACE,qCAAA;EACA,+CAAA;AAZR;AAiBQ;EAEE,4CAAA;AAhBV;AAmBU;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,cAAA;EACA,uBAAA;EACA,wBAAA;EACA,qCAAA;EACA,qBAAA;EACA,oBAAA;AAjBZ;AAsBI;EACE,YAAA;AApBN;AAsBI;EACE,gBAAA;EACA,qDAAA;EACA,UAAA;AApBN;AAqBM;EACE,qCAAA;EACA,6CAAA;AAnBR;AAuBM;EACE,yDAAA;AArBR;AAyBM;EACE,sDAAA;AAvBR;AA2BE;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAzBJ;AA0BI;;EAEE,gBAAA;EACA,UAAA;AAxBN;AA0BI;EACE,WAAA;AAxBN;AA0BI;EACE,SAAA;AAxBN;AA0BI;EACE,gBAAA;EACA,WAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,sBAAA;AAxBN;AA0BI;EACE,wCAAA;AAxBN;AA2BE;EACE,4CAAA;AAzBJ;;AA6BE;EACE,SAAA;AA1BJ","sourcesContent":[".Table {\n  --sp-table-bold: 700;\n  --sp-table-regular: 500;\n  --sp-table-gutter-x: 0.5rem;\n  --sp-table-gutter-y: 0.65rem;\n  --sp-border-color: #ccc;\n  --sp-table-header-bg: #fff;\n  --sp-table-footer-bg: #fff;\n  --sp-table-row-height: calc(var(--sp-table-gutter-y) * 2 + 1.5rem);\n  --sp-table-sort-indicator-color: rgba(0, 0, 0, 0.25);\n  --sp-table-alternate-shading: rgba(197, 197, 197, 0.2);\n\n  position: relative;\n  display: flex;\n  gap: 0.5rem;\n  width: 100%;\n  &:has(.Table-Controls) {\n    width: calc(100% + 3.5rem);\n  }\n  table {\n    position: relative;\n    flex-grow: 1;\n    width: 100%;\n    height: 100%;\n    border-spacing: 0;\n    .TableRow {\n      position: relative;\n      display: block;\n      .TableCell {\n        position: relative;\n        display: inline-flex;\n        .TableCell-Content {\n          position: relative;\n          flex-grow: 1;\n          min-height: var(--sp-table-row-height);\n          font-weight: var(--sp-table-regular);\n          padding: var(--sp-table-gutter-y) calc(var(--sp-table-gutter-x) / 2);\n          overflow: hidden;\n          white-space: nowrap;\n          text-overflow: ellipsis;\n          .SortingIndicator {\n            padding: var(--sp-table-gutter-y) 0;\n            margin-left: var(--sp-table-gutter-x);\n            color: var(--sp-table-sort-indicator-color);\n            &.SortingIndicator-asc,\n            &.SortingIndicator-desc {\n              color: inherit;\n            }\n          }\n        }\n        &.alternate {\n          background-color: var(--sp-table-alternate-shading);\n        }\n        &:has(.SortingIndicator) {\n          cursor: pointer;\n        }\n        &:first-child {\n          .TableCell-Content {\n            padding-left: var(--sp-table-gutter-x);\n          }\n        }\n        &:last-child {\n          .TableCell-Content {\n            padding-right: var(--sp-table-gutter-x);\n          }\n        }\n        &[data-prefix] {\n          --prefix: attr(data-prefix);\n          .TableCell-Content {\n            &:before {\n              content: var(--prefix);\n              display: inline;\n              color: rgba(0, 0, 0, 0.5);\n            }\n          }\n        }\n        &[data-suffix] {\n          --suffix: attr(data-suffix);\n          .TableCell-Content {\n            &:after {\n              content: var(--suffix);\n              display: inline;\n              color: rgba(0, 0, 0, 0.5);\n            }\n          }\n        }\n        &[data-placeholder] {\n          --placeholder: attr(data-placeholder);\n          .TableCell-Content:empty {\n            &:before {\n              content: var(--placeholder);\n              display: inline;\n              color: rgba(0, 0, 0, 0.5);\n            }\n          }\n        }\n      }\n      &.TableRow-Header {\n        .TableCell {\n          .TableCell-Content {\n            text-transform: uppercase;\n            font-weight: var(--sp-table-bold);\n            &:has(.SortingIndicator) {\n              cursor: pointer;\n            }\n          }\n        }\n      }\n    }\n    .TableCollapse {\n      box-shadow: 0 2px 0 -1px var(--sp-border-color);\n      td {\n        padding: 0;\n      }\n    }\n    .Table-Head {\n      position: sticky;\n      top: 0;\n      z-index: 2;\n      > .TableRow {\n        background: var(--sp-table-header-bg);\n        box-shadow: 0 2px 0 -1px var(--sp-border-color);\n      }\n    }\n    .Table-Body {\n      > .TableRow {\n        &:has(+ .TableRow),\n        &:has(+ .TableCollapse) {\n          box-shadow: 0 1px 0 0 var(--sp-border-color);\n        }\n        &:hover {\n          &:after {\n            content: '';\n            position: absolute;\n            top: 0;\n            left: 0;\n            display: block;\n            width: calc(100% - 1px);\n            height: calc(100% - 0px);\n            border: 3px solid var(--bs-secondary);\n            border-radius: 0.5rem;\n            pointer-events: none;\n          }\n        }\n      }\n    }\n    .Table-End {\n      height: 1rem;\n    }\n    .Table-Foot {\n      position: sticky;\n      bottom: calc((var(--sp-table-row-height) + 3px) * -1);\n      z-index: 1;\n      > .TableRow {\n        background: var(--sp-table-footer-bg);\n        box-shadow: 0 -1px 0 0 var(--sp-border-color);\n      }\n    }\n    &:has(thead) {\n      .TableRow {\n        scroll-margin-top: calc(var(--sp-table-row-height) + 2px);\n      }\n    }\n    &:has(tfoot) {\n      .TableRow {\n        scroll-margin-bottom: calc(var(--sp-table-row-height));\n      }\n    }\n  }\n  .Table-Controls {\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n    flex-grow: 0;\n    padding: 0.5rem 0;\n    .Table-ScrollDown,\n    .Table-ScrollUp {\n      position: sticky;\n      z-index: 2;\n    }\n    .Table-ScrollDown {\n      top: 0.5rem;\n    }\n    .Table-ScrollUp {\n      top: 100%;\n    }\n    .Table-Addons {\n      position: sticky;\n      top: 3.4rem;\n      bottom: 3.4rem;\n      display: flex;\n      flex-direction: column;\n      gap: 0.5rem;\n      padding-bottom: 2.9rem;\n    }\n    .btn-secondary-subtle {\n      border: 1px solid var(--sp-border-color);\n    }\n  }\n  strong {\n    font-weight: var(--sp-table-bold) !important;\n  }\n}\n.Table .Table {\n  .Table-End {\n    height: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
